import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface EyebrowProps {
    children: ReactNode
    className?: string
    tone?: 'onDark' | 'onLight'
}

// Small mono label introduced by a line that ends in a station, echoing the Netzplan.
export const Eyebrow: FC<EyebrowProps> = ({ children, className, tone = 'onLight' }): ReactNode => {
    return (
        <p
            className={cn(
                'flex items-center gap-3 font-mono text-xs font-medium tracking-[0.14em] uppercase',
                tone === 'onDark' ? 'text-petrol-200' : 'text-muted-foreground',
                className
            )}
        >
            <svg viewBox='0 0 30 10' aria-hidden='true' focusable='false' className='h-2.5 w-7.5 shrink-0'>
                <line x1='0' y1='5' x2='21' y2='5' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />

                <circle
                    cx='25'
                    cy='5'
                    r='3.2'
                    fill='none'
                    strokeWidth='2'
                    className={tone === 'onDark' ? 'stroke-signal-400' : 'stroke-signal-600'}
                />
            </svg>

            <span>
                {children}
            </span>
        </p>
    )
}
